import { render } from "./stripeConfigDetails.vue?vue&type=template&id=bd001cb6&ts=true"
import script from "./stripeConfigDetails.vue?vue&type=script&lang=ts"
export * from "./stripeConfigDetails.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__